import { Component, Input } from '@angular/core';
import { IMcbKundenstimmenGruppe } from 'src/rest-interfaces/IModularContent.field';


@Component( {
  selector: 'app-kundenstimmen-gruppe',
  templateUrl: './kundenstimmen-gruppe.component.html'
} )
export class KundenstimmenGruppeComponent {
  @Input() public content: IMcbKundenstimmenGruppe;
  public kundenstimmenLink = '/kundenstimmen';

  public getGridCssCellClasses( i: number ): string {

    const rowNoL = Math.floor( i / 2 ) + 1;
    const colNoL = i % 2;
    const rowNoXL = Math.floor( i / 3 ) + 1;
    const colNoXL = i % 3;

    const colStartL = Math.floor( colNoL * 12 ) + 2;
    const colEndL = colStartL + 10;

    const colStartXL = Math.floor( colNoXL * 8 ) + 2;
    const colEndXL = colStartXL + 6;

    const gridClasses = [
      'row-s-' + ( i + 1 ).toString(),
      'col-s-3-22',
      'row-l-' + rowNoL,
      'col-l-' + colStartL.toString() + '-' + colEndL.toString(),
      'row-xl-' + rowNoXL,
      'col-xl-' + colStartXL.toString() + '-' + colEndXL.toString(),
    ];

    return gridClasses.join( ' ' );
  }

  public getLinkText(url: string): string {
    if (url.includes("/projekte/")) {
      return "Zum Projekt";
    } else if (url.includes("/journal/")) {
      return "Zum Artikel";
    } else {
      return "Mehr erfahren"; // fallback text
    }
  }
}